export default "__VITE_ASSET__5a9f3e1f__"